(function () {
  function formatMoney(cents) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n + '\u00a0€';
  }

  function getOptionsFromSelects(root) {
    var selects = root.querySelectorAll('.product-variant-option__select');
    var out = [];
    selects.forEach(function (sel) {
      out.push(sel.value);
    });
    return out;
  }

  function findVariant(variants, optionValues) {
    return variants.find(function (v) {
      for (var i = 0; i < optionValues.length; i++) {
        var key = 'option' + (i + 1);
        if (v[key] !== optionValues[i]) return false;
      }
      return true;
    });
  }

  function initSection(section) {
    var sid = section.getAttribute('data-section-id');
    if (!sid) return;

    var script = document.getElementById('ProductVariantsJson-' + sid);
    if (!script) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var form = section.querySelector('form.shopify-product-form, form[action*="/cart/add"]');
    if (!form) form = section.querySelector('form.product-form');
    if (!form) form = section.querySelector('form');
    if (!form) return;

    var idInput = form.querySelector('[data-variant-id-input]') || form.querySelector('input[name="id"]');
    var priceEl = section.querySelector('[data-current-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var oneTimePrice = section.querySelector('[data-one-time-price]');
    var mainImg = document.getElementById('ProductMainImg-' + sid);

    function applyVariant(variant) {
      if (!variant || !idInput) return;

      idInput.value = String(variant.id);

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (oneTimePrice) oneTimePrice.textContent = formatMoney(variant.price);

      if (addBtn) {
        var la = addBtn.getAttribute('data-label-available');
        var ls = addBtn.getAttribute('data-label-soldout');
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = la || 'Lisää ostoskoriin';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = ls || 'Loppuunmyyty';
        }
      }

      if (mainImg && variant.featured_image && variant.featured_image.src) {
        var w = mainImg.width || 800;
        var src = variant.featured_image.src;
        if (src.indexOf('?') === -1) src += '?width=' + w;
        else if (src.indexOf('width=') === -1) src += '&width=' + w;
        mainImg.src = src;
        mainImg.alt = variant.featured_image.alt || mainImg.alt;
      }

      var planRadios = form.querySelectorAll('[data-selling-plan-radio]');
      if (planRadios.length) {
        planRadios[0].checked = true;
      }
    }

    function onVariantChange() {
      var selects = section.querySelectorAll('.product-variant-option__select');
      var variant;
      if (!selects.length) {
        variant =
          variants.find(function (v) {
            return String(v.id) === idInput.value;
          }) || variants[0];
      } else {
        var opts = getOptionsFromSelects(section);
        variant = findVariant(variants, opts);
      }
      if (variant) applyVariant(variant);
    }

    section.querySelectorAll('.product-variant-option__select').forEach(function (sel) {
      sel.addEventListener('change', onVariantChange);
    });

    section.querySelectorAll('.product-media__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        var alt = btn.getAttribute('data-alt');
        if (mainImg && src) {
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
        }
        section.querySelectorAll('.product-media__thumb').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
      });
    });

    form.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.querySelector('[data-quantity-input]');
        if (!input) return;
        var q = parseInt(input.value, 10) || 1;
        if (btn.getAttribute('data-pdp-qty') === 'increase') q += 1;
        else q = Math.max(1, q - 1);
        input.value = String(q);
      });
    });

    onVariantChange();
  }

  document.querySelectorAll('[data-product-form]').forEach(initSection);
})();
